import '../styles/DashboardQuickRoutes.css';
import React from 'react';

const ROUTE_TILES = [
  {
    id: 'new-test-run',
    label: 'New Test Run',
    description: 'Configure a wordlist or mask, threads and policy, then launch.',
    href: '/new-test-run',
  },
  {
    id: 'run-monitor',
    label: 'Run Monitor',
    description: 'Watch a job progress with a stepped fill and a live log.',
    href: '/run-monitor',
  },
  {
    id: 'results',
    label: 'Results',
    description: 'Review weak findings as fail and pass sticker chips.',
    href: '/results',
  },
  {
    id: 'history',
    label: 'History',
    description: 'Reopen past runs from the local store and re-export them.',
    href: '/history',
    support: true,
  },
];

function DashboardQuickRoutes() {
  return (
    <section className="dqr-root" aria-labelledby="dqr-heading">
      <div className="dqr-block" data-content-rail="workspace">
        <div className="dqr-head">
          <h2 id="dqr-heading" className="dqr-head__label">
            Quick routes
          </h2>
          <span className="dqr-head__meta">Working surfaces · 04</span>
        </div>

        <nav className="dqr-grid" aria-label="Working surfaces">
          {ROUTE_TILES.map((tile) => (
            <a
              key={tile.id}
              href={tile.href}
              className={`dqr-tile${tile.support ? ' dqr-tile--support' : ''}`}
            >
              <span className="dqr-tile__top">
                <span className="dqr-tile__label">{tile.label}</span>
                <span className="dqr-tile__mark" aria-hidden="true">↗</span>
              </span>
              <span className="dqr-tile__desc">{tile.description}</span>
            </a>
          ))}
        </nav>

        <div className="dqr-foot">
          <span className="dqr-sticker">
            <span className="dqr-sticker__dot" aria-hidden="true" />
            Authorized target only
          </span>
          <a href="/login" className="dqr-signout">
            Sign out
            <span className="dqr-signout__arrow" aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default DashboardQuickRoutes;